// extracted by mini-css-extract-plugin
export default {"navbarContainer":"navbar_navbarContainer__DrP8-","appName":"navbar_appName__I5wGK","navLinks":"navbar_navLinks__B10zd"};